import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import i18n from '@/services/translation/i18n';
import { Loader } from '@/components/blocks';
import './styles/index.scss';

import reportWebVitals from './reportWebVitals';
import { defineCustomElements } from '@twintag/twintag-core/loader';

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <Suspense fallback={<Loader />}>
            <App />
        </Suspense>
    </I18nextProvider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

defineCustomElements(window);

declare global {
    namespace JSX {
        interface IntrinsicElements {
            'twintag-preview': any;
        }
    }
}
